import { defineMessages } from '@sm/intl';
import PROJECT_NAME from '~app/pages/Pricing/constants/project';

const COPY = defineMessages({
  DISCOUNT_TEXT: {
    id: 'Pricing.copy.DiscountBannerText',
    defaultMessage: '<strong>GET 15% OFF</strong> your first year of Teams',
    desc: {
      id: 'Pricing.copy.DiscountBannerText',
      message: '[Type: label][Vis: high] - Pricing discount for Teams',
      project: PROJECT_NAME,
    },
  },
  VIEW_PLANS_BUTTON: {
    id: 'Pricing.copy.ViewPlansButtonText',
    defaultMessage: 'View Plans',
    desc: {
      id: 'Pricing.copy.ViewPlansButtonText',
      message: '[Type: button][Vis: med] - Link to pricing teams details page',
      project: PROJECT_NAME,
    },
  },
});

export default COPY;
